module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/servico/servico.component.css
// module id = ./src/app/servico/servico.component.css
// module chunks = main